export default __webpack_public_path__ + "static/media/mediumSchool.44f9c0ed.svg";